// PractitionersTable Component
const PractitionersTable = () => (
        <div className="overflow-x-auto">
                <table className="table table-bordered w-full">
                        <thead>
                                <tr>
                                        <th></th>
                                        <th colSpan="2">Monday</th>
                                        <th colSpan="2">Tuesday</th>
                                        <th colSpan="2">Wednesday</th>
                                        <th colSpan="2">Thursday</th>
                                        <th colSpan="2">Friday</th>
                                </tr>
                        </thead>
                        <tbody>
                                {/* Practitioner Sections */}
                                {[
                                        { name: 'David Vivian', data: [] },
                                        { name: 'Paul Verrills', data: [] },
                                        { name: 'Michael Chen', data: [] }
                                ].map(practitioner => (
                                        <PractitionerSection
                                                key={practitioner.name}
                                                name={practitioner.name}
                                                data={[
                                                        {
                                                                location: 'CR#2',
                                                                activity: 'PR',
                                                                time: '1:00-1:15pm'
                                                        },
                                                        // Add more days
                                                ]}
                                        />
                                ))}
                        </tbody>
                </table>
        </div>
);

export default PractitionersTable;